import { render, staticRenderFns } from "./parameters.pug?vue&type=template&id=c4b95a04&lang=pug&"
import script from "./parameters.js?vue&type=script&lang=js&"
export * from "./parameters.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4b95a04')) {
      api.createRecord('c4b95a04', component.options)
    } else {
      api.reload('c4b95a04', component.options)
    }
    module.hot.accept("./parameters.pug?vue&type=template&id=c4b95a04&lang=pug&", function () {
      api.rerender('c4b95a04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/views/parameters/index.vue"
export default component.exports